import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {ref, onMounted, onUnmounted} from 'vue'
  import HeaderCpn from './components/Header/HeaderCpn.vue'
  import MainCpn from './components/Main/MainCpn.vue'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'IndexView',
  setup(__props) {

  const container = ref<HTMLElement>()


  onMounted(() => {
    window.addEventListener('dblclick', handlefullScreen)
  })

  onUnmounted(() => {
    window.removeEventListener('dblclick', handlefullScreen)
  })

  const handlefullScreen = () => {
    const fullscreenElement = document.fullscreenElement
    if (!fullscreenElement) {
      container.value?.requestFullscreen()
    } else {
      document.exitFullscreen()
    }
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "layput-container",
    ref_key: "container",
    ref: container
  }, [
    _createVNode(HeaderCpn),
    _createVNode(MainCpn)
  ], 512))
}
}

})